import { createFileRoute } from '@tanstack/react-router';

import { SectionLayout } from '@/features/app-shell/components/SectionLayout';
import { useNavViewer } from '@/features/app-shell/hooks/useNavViewer';
import {
  INTEGRATIONS_TABS,
  visibleNavItems,
  type NavItem,
} from '@/features/app-shell/navigation';
import { useConnectedCount } from '@/features/connections';

const CONNECTIONS_TAB = '/workspaces/$workspaceId/integrations/connections';

// What connects the workspace to the outside, as tabs of one entry (spec 224).
export const Route = createFileRoute('/workspaces/$workspaceId/integrations')({
  component: IntegrationsRoute,
});

export function IntegrationsRoute() {
  const { workspaceId } = Route.useParams();
  // The Connections tab carries its count (spec 229 FR-005), read only for a
  // viewer the strip offers the tab to: a reader never makes the request.
  const viewer = useNavViewer(workspaceId);
  const maySeeConnections = visibleNavItems(INTEGRATIONS_TABS, viewer).some(
    (tab) => tab.to === CONNECTIONS_TAB,
  );
  const connected = useConnectedCount(workspaceId, {
    enabled: maySeeConnections,
  });
  const tabs: NavItem[] = INTEGRATIONS_TABS.map((tab) =>
    tab.to === CONNECTIONS_TAB && connected !== undefined
      ? { ...tab, tabBadge: { count: connected } }
      : tab,
  );
  return (
    <SectionLayout
      title="Integrations"
      // The band every main page of a workspace carries (spec 227).
      surface="inverse"
      tabs={tabs}
      workspaceId={workspaceId}
    />
  );
}
